import * as React from "react";

import {cs}                 from "@Common/react/chain-services";
import {consumeContext}     from "@Common/react/context";
import {Load2}              from "@Common/react/load2";
import {UseState}           from "@Common/react/use-state";
import {
    AGENT_LEVEL, 
    OFFICE_LEVEL
}                           from "@Xpresso/routes/common/logic/user-level";
import {AccountTabsLayout}  from "@Xpresso/routes/account/common/account-tabs-layout/account-tabs-layout";
import {AnalyticsLayout}    from "./analytics-layout/analytics-layout";

export const AnalyticsRoute = ({}) => cs(
    consumeContext("accountMenu"),
    consumeContext("apis"),
    consumeContext("session"),
    consumeContext("userLevels"),
    ({accountMenu}, next) => AccountTabsLayout({
        activeMenu: "analytics",
        activeTab: "analytics",
        config: accountMenu?.myProfileMenu?.subMenu ?? [],
        next,
    }),
    ["isInternalUser", ({userLevels}, next) => next(userLevels?.internalUser)],
    ["idAgent", ({session, userLevels}, next) => UseState({
        initValue: userLevels.userLevel === AGENT_LEVEL ? session?.value?.agentId : null,
        next,
    })],
    ["idBranch", ({session, userLevels}, next) => UseState({
        initValue: userLevels.userLevel === OFFICE_LEVEL ? session?.value?.branchId : null,
        next,
    })],
    ["leadInteractions", ({apis, idAgent}, next) => Load2({
        fetch: () => idAgent.value && apis.next.analytics.leadInteractions(idAgent.value),
        _key: idAgent.value,
        next,
    })],
    ({leadInteractions, idAgent, userLevels, idBranch, isInternalUser}) => (
        <AnalyticsLayout
            {...{
                leadInteractions,
                idAgent,
                isInternalUser
            }}
            userLevel={userLevels.userLevel}
            idBranch={idBranch.value}
        />
    )    
);